var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBolaHitos(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    style: {
      enableBackground: "new 0 0 35 35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#D2617E;}\n\t.st1{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bola-revision") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    className: "st0",
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.4,17.1l1-5.2c0-0.1,0-0.3-0.1-0.4s-0.2-0.2-0.3-0.2h-3.2V8c0-0.2-0.2-0.4-0.4-0.4H10.4V6.7 c0-0.2-0.2-0.4-0.4-0.4h-2c-0.2,0-0.4,0.2-0.4,0.4v21.6c0,0.2,0.2,0.4,0.4,0.4h2c0.2,0,0.4-0.2,0.4-0.4V20h7.4v2.4 c0,0.2,0.2,0.4,0.4,0.4h8.9c0.1,0,0.3-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.1-0.4L26.4,17.1z M9.5,27.9H8.4V7.1h1.1V27.9z M18.6,20h3.1 l-3.1,1.7V20z M19.9,22l3.7-2c0.1-0.1,0.2-0.2,0.2-0.4v-1.9c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4v1.5H10.4V8.5H23v5.2 c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4v-1.4h2.7l-1,4.8c0,0.1,0,0.1,0,0.2l1,4.8H19.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.7,15.3c-0.2-0.1-0.4-0.1-0.5,0c-0.1,0.1-0.2,0.3-0.2,0.5c0.1,0.2,0.2,0.3,0.4,0.3c0.2,0,0.4-0.1,0.4-0.3 C23.9,15.6,23.8,15.4,23.7,15.3L23.7,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.7,9.7c-2.2,0-3.9,1.8-3.9,3.9s1.8,3.9,3.9,3.9c2.2,0,3.9-1.8,3.9-3.9C20.6,11.5,18.8,9.7,16.7,9.7z  M16.7,16.7c-1.7,0-3-1.4-3-3s1.4-3,3-3s3,1.4,3,3S18.3,16.7,16.7,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.7,12.7c-0.2-0.1-0.5-0.1-0.6,0.1l-0.7,0.9l-0.3-0.3c-0.2-0.2-0.5-0.2-0.6,0c-0.2,0.2-0.2,0.5,0,0.6 l0.7,0.7c0.1,0.1,0.2,0.1,0.3,0.1c0,0,0,0,0,0c0.1,0,0.2-0.1,0.3-0.2l1-1.3C18,13.1,17.9,12.9,17.7,12.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolaHitos);
export default __webpack_public_path__ + "static/media/bola-hitos.39f600161acb5f1941b946e28d8ab169.svg";
export { ForwardRef as ReactComponent };